import Cookies from "../../cookies";
import BasicRecord from "../BasicRecord";

const signupMethods: BasicRecord = {
    figma: "Sign up with Figma",
    googleSignIn: "Sign up with Google",
    googleOneTap: "Google One Tap",
    SAML: "Sign up with SSO"
};

export default function getSignupMethod(): string | undefined {
    const authSource = Cookies.get("authSource") as string;
    Cookies.remove("authSource");
    return signupMethods[authSource];
}
